import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { oapi, addonIsActive } from '@/lib/officialsApi';
import { AddonSubscribeButton } from './AddonSubscribeButton';

export const OfficialsAddonPricingCard = () => {
  const { user } = useAuth();
  const [plan, setPlan] = useState(null);
  useEffect(() => { oapi('/officials/billing/plan').then(setPlan).catch(() => {}); }, []);
  const active = addonIsActive(user);
  const price = plan?.price ?? 299;
  return (
    <section className="max-w-5xl mx-auto mb-12 rounded-3xl bg-[#00247D] text-white p-6 sm:p-10 grid md:grid-cols-12 gap-6 relative overflow-hidden" data-testid="officials-addon-pricing-card">
      <ShieldCheck className="absolute -left-12 -bottom-12 w-56 h-56 text-white/5" strokeWidth={1} />
      <div className="md:col-span-7 relative">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-amber-300">Add-on · works with any plan</p>
        <h3 className="text-3xl sm:text-4xl font-black uppercase mt-2 leading-none" style={{ fontFamily: 'Barlow Condensed' }}>Officials Scheduling</h3>
        <p className="text-white/80 mt-3 text-sm sm:text-base">Assign referees and officials to your games, collect availability, catch conflicts and send confirmations and reminders automatically. Officials join free.</p>
        <ul className="mt-5 grid sm:grid-cols-2 gap-2">
          {(plan?.features || []).slice(0, 6).map(f => <li key={f} className="flex gap-2 text-xs sm:text-sm text-white/90"><Check className="w-4 h-4 text-amber-300 shrink-0 mt-0.5" />{f}</li>)}
        </ul>
      </div>
      <div className="md:col-span-5 relative flex flex-col justify-center md:items-end md:text-right">
        <div className="flex items-end gap-1">
          <span className="text-5xl sm:text-6xl font-black leading-none" style={{ fontFamily: 'Barlow Condensed' }} data-testid="addon-pricing-price">${price}</span>
          <span className="text-white/70 mb-1"><span className="text-sm font-bold text-white/80" data-testid="addon-pricing-currency">USD</span> / year</span>
        </div>
        <p className="text-xs text-white/60 mt-1">Added on top of Free or Pro</p>
        {active ? (
          <Link to="/officials"><Button className="mt-5 bg-white text-[#00247D] hover:bg-white/90 font-bold" data-testid="addon-open-hub-btn">Open Officials Hub</Button></Link>
        ) : (
          <AddonSubscribeButton price={price} className="mt-5 h-11 px-6" label="Add Officials Scheduling" testId="pricing-addon-subscribe-btn" />
        )}
        <Link to="/officials" className="text-xs text-white/70 hover:text-white underline mt-3" data-testid="addon-learn-more">See how it works</Link>
      </div>
    </section>
  );
};
